import React from 'react';
import {
  string,
  objectOf,
  oneOfType,
  number,
} from 'prop-types';
import DefaultParagraph from '../../typeface/DefaultParagraph';

const SideHeading = ({
  textStyle,
  style,
  className,
  textClassName,
  firstHeading,
  secondHeading,
}) => (
  <div
    style={{
      writingMode: 'vertical-rl',
      textOrientation: 'mixed',
      paddingRight: 12,
      ...style,
    }}
    className={['sideHeading', className].join(' ')}
  >
    <DefaultParagraph
      size="small"
      style={{
        ...textStyle,
      }}
      className={textClassName}
    >
      {firstHeading}
    </DefaultParagraph>
    <DefaultParagraph
      small
      style={{
        marginRight: '-8px',
        ...textStyle,
      }}
      className={textClassName}
    >
      {secondHeading}
    </DefaultParagraph>
  </div>
);

SideHeading.propTypes = {
  style: objectOf(oneOfType([
    string,
    number,
  ])),
  className: string,
  textStyle: objectOf(oneOfType([
    string,
    number,
  ])),
  textClassName: string,
  firstHeading: string,
  secondHeading: string,
};

SideHeading.defaultProps = {
  style: null,
  className: null,
  textStyle: null,
  textClassName: null,
  firstHeading: null,
  secondHeading: null,
};

export default SideHeading;
